'use client';

import { useNoTracking } from '@/app/hooks/useNoTracking';
import { ReactNode } from 'react';

export function TrackingGuard({ children }: { children: ReactNode }) {
  const noTracking = useNoTracking();
  if (noTracking) return null;
  return <>{children}</>;
}
